import { BrowserRouter as Router, Route, Routes} from "react-router-dom"
import Navbar from "./components/layout/Navbar"
import { NasaProvider } from "./context/nasa/NasaContext"
import Home from "./pages/Home"
import About from "./pages/About"
function App() {
  return (
    <NasaProvider>
      <Router>
      <Navbar />
      <div className="container">
        
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
        </Routes>
      </div>
      </Router>
    </NasaProvider>
  );
}

export default App;
